import * as React from 'react';
import styled from 'styled-components';

import { Selector } from '@longline/aqua-ui/inputs/Selector';

interface IProps {
  /** Value is positive (navy) bathymetry or negative (army) bathymetry. */
  value?: 'positive' | 'negative';
  /** Fired when control value changes. */
  onChange?: (value: 'positive' | 'negative') => void;
}

const BathymetryFormatControl = (props: IProps) =>
  <Wrapper>
    <Selector name="positive" dark type='circle' label="Navy (positive bathymetry)" checked={props.value == 'positive'} onChange={() => props.onChange?.('positive')}/>
    <Selector name="negative" dark type='circle' label="Army (negative bathymetry)" checked={props.value == 'negative'} onChange={() => props.onChange?.('negative')}/>
  </Wrapper>

const Wrapper = styled.div`
  padding: 8px 0 4px 16px;
`

export { BathymetryFormatControl }
